import { render, staticRenderFns } from "./DiscountPopup.vue?vue&type=template&id=b4e84b4c"
import script from "./DiscountPopup.vue?vue&type=script&lang=js"
export * from "./DiscountPopup.vue?vue&type=script&lang=js"
import style0 from "./DiscountPopup.vue?vue&type=style&index=0&id=b4e84b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports